import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CouldNotReadQuoteInfoException extends QuoteException {
}